import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=4c702076&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=js&"
export * from "./Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c702076",
  null
  
)

component.options.__file = "Dialog.vue"
export default component.exports